export const CATEGORY_TEST_IDS: { [key: string]: string } = {
  RELATED_CATEGORY_SECTION: 'relatedCategorySection',
  CATEGORY_SEO_DESCRIPTION: 'categorySeoDescription',
  MAIN_CATEGORY_BUTTON: 'mainCategoryButton',
  SUB_CATEGORY_BUTTON: 'subCategoryButton',
} as const;
